import { css } from '@emotion/css';
import React, { useEffect, useState } from 'react';

import { GrafanaTheme2 } from '@grafana/data';
import { Input, useStyles2, useTheme2 } from '@grafana/ui';
import lokiGrammar from 'app/plugins/datasource/loki/syntax';
import { RawQuery } from 'app/plugins/datasource/prometheus/querybuilder/shared/RawQuery';

interface Props {
  value: string;
  isEditing?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
  error?: string;
}

export const EditableCell = ({ isEditing, value, disabled, error, onChange }: Props) => {
  const [cellValue, setCellValue] = useState(value);
  const theme = useTheme2();
  const styles = useStyles2(getStyles);

  useEffect(() => {
    if (!isEditing) {
      setCellValue(value);
    }
  }, [isEditing, value]);

  return (
    <div className={styles.wrapper}>
      {isEditing ? (
        <Input
          value={cellValue}
          onChange={(event) => {
            setCellValue(event.currentTarget.value);
            if (onChange) {
              onChange(event.currentTarget.value);
            }
          }}
          invalid={!!error}
        />
      ) : (
        <span style={{ color: disabled ? theme.colors.text.disabled : 'unset' }}>
          <RawQuery query={`{ ${value} }`} lang={{ grammar: lokiGrammar, name: 'logql' }} />
        </span>
      )}
    </div>
  );
};

const getStyles = (theme: GrafanaTheme2) => {
  return {
    wrapper: css({
      padding: theme.spacing(0, 1),
    }),
  };
};
